import { useProgress } from 'components/providers/ProgressProvider'
import {
  resetConvertedGroupState,
  updateGroupPersonalSyncStatus,
  updateLinkOnServer
} from 'services/api/group'
import LocalStorage from 'services/LocalStorage'
import { GroupDoc } from 'types/api/changes'
import { GROUP_INFO_ACTION_TYPES } from 'types/api/group'
import { Model } from 'types/model'
import { LocalStorageKey } from 'types/services/localStorage'
import { getOrUpdateDeviceId } from 'utils/device'
import { GENERIC_ERROR } from 'utils/strings'
import { TextButton } from '../styled'
import { TextButtonContainer } from './styled'

import { t } from 'i18next'
import { isConvertedGroup } from 'utils/api/group_state'
import { useState } from 'react'
import AreYouSureDialog from 'components/dialogs/AreYouSureDialog'
import { PopupSectionRow } from 'components/popup/PopupSectionRow'
import { DisableLink } from 'assets/icons/group-details'
import Button from 'components/buttons/Button'

interface RemoveLinkRowProps {
  group: Model<GroupDoc>
}

export default function RemoveLinkRow(props: RemoveLinkRowProps) {
  const progress = useProgress()

  const [showSureDialog, setShowSureDialog] = useState(false)

  const removeLinkFromGroup = async () => {
    progress.setLoading(true)
    const future = updateLinkOnServer(
      {
        PrivateLinkUrl: '',
        PrivateLinkPassword: '',
        ActionType: GROUP_INFO_ACTION_TYPES.METADATA,
        UserID: LocalStorage.get(LocalStorageKey.USER_ID) ?? '',
        GroupID: props.group._id,
        DeviceChangeID: getOrUpdateDeviceId()
      },
      props.group
    )
    future
      .catch((error) => {
        progress.setError(GENERIC_ERROR)
      })
      .finally(() => {
        progress.setLoading(false)
      })
  }

  return (
    <div style={{ marginTop: 4, marginBottom: 4 }}>
      <PopupSectionRow
        action={() => {
          setShowSureDialog(true)
        }}
        icon={<DisableLink />}
        iconClass="icon-xs"
        explanation={t('disableLinkDesc')}
        value={<Button size="xs">{t('delete')}</Button>}
        title={t('disableLink')}
      />
      {showSureDialog && (
        <AreYouSureDialog
          title={t('areYouSure')}
          message={t('disableLinkDesc')}
          sureAction={function (): void {
            removeLinkFromGroup()
          }}
          open={showSureDialog}
          approveButtonText={t('disableLinkButton')}
          hide={function (): void {
            setShowSureDialog(false)
          }}
        />
      )}
    </div>
  )
}
